export const foxyAddresses = [
  {
    staking: '0xee77aa3Fd23BbeBaf94386dD44b548e9a785ea4b',
    liquidityReserve: '0x8EC637Fe2800940C7959f9BAd4fE69e41225CD39',
    fox: '0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d',
    foxy: '0xDc49108ce5C57bc3408c3A5E95F3d864eC386Ed3',
    version: 1,
  },
]

export const tokeRewardHashAddress = '0x5ec3EC6A8aC774c7d53665ebc5DDf89145d02fB6'
export const tokePoolAddress = '0x808D3E6b23516967ceAE4f17a5F9038383ED5311'
export const tokeManagerAddress = '0xa86e412109f77c45a3bc1c5870b880492fb86a14'
